exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notifications{position:fixed;top:50px;right:0;z-index:1257;pointer-events:none}@media print,screen and (min-width:769px){.notifications{max-width:320px}}.notifications .notification{margin:20px}.notification{position:relative;min-width:240px;-webkit-backface-visibility:hidden;backface-visibility:hidden;transform:translateZ(0);pointer-events:all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ca4d75c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-bulma-notification/src/Notification.vue
// module id = 38
// module chunks = 4